import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosAccordion } from './components/BonosAccordion';
import { MidTestimonials } from './components/MidTestimonials';
import { ContentCarousel } from './components/ContentCarousel';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { Objections } from './components/Objections';
import { SupportFooter } from './components/SupportFooter';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    window.fbq('init', '1252242806993118');
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-zinc-100 selection:bg-amber-400/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Problems data-id="element-2" />
      <TomosAccordion data-id="element-3" />
      <MidTestimonials data-id="element-4" />
      <BonosAccordion data-id="element-5" />
      <ContentCarousel data-id="element-6" />
      <PurchaseSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Objections data-id="element-9" />
      <SupportFooter data-id="element-10" />
      <SalesPopup data-id="element-11" />
    </div>;
}